<template>
  <div class="data-not-filled">
    <img
      class="img-fluid data-not-filled__img"
      src="@/assets/img/icon-close-not-data.png"
      alt="icon close"
      title="icon close"
    />
    <p class="data-not-filled__text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.data-not-filled {
  width: max-content;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: var(--white);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  margin: 0 auto;
  @media (max-width: 991px) {
    padding: 15px;
  }
  &__img {
    max-width: 32px;
    @media (max-width: 991px) {
      max-width: 16px;
    }
  }
  &__text {
    font-size: 24px;
    font-family: "Font Light";
    color: var(--red-dark);
    line-height: 1.2;
    margin-bottom: 0;
    @media (max-width: 991px) {
      font-size: 12px;
    }
  }
}
</style>
